module.exports = __webpack_public_path__ + "img/circle-user.3c633713.svg";